import React, { useState, useEffect } from 'react';
import styles from '../../styles/PodcastPlayerBar.module.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'next/image';
import * as LIB from '../../lib/common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle, faPauseCircle, } from '@fortawesome/fontawesome-free-regular';
import { faFastBackward, faFastForward, faRedoAlt, faUndoAlt, faSlash } from '@fortawesome/free-solid-svg-icons';

const PodcastPlayerBar = ({
    title, totalDuration, currentPosition, playPauseButtonState,
    onClickPlayPause, onClickPrevTrack, onClickNextTrack, onSeekBarChanged, onClickTitle, onToggleRepeat, onClickRewind
}) => {

    const REPEAT_OFF = '0';
    const REPEAT_ONE = '1';
    // const REPEAT_ALL = '2';
    // const REPEAT_ONE_OFF = '3';
    
    const [seeking, setSeeking] = useState(false);
    const [repeatMode, setRepeatMode] = useState(REPEAT_OFF);
    const [autoPlay, setAutoPlay] = useState(true);
    
    const playIcon = <Image src={LIB.getBasepath('/images/player/play.svg')} width={22} height={22}/>
    const stopIcon = <Image src={LIB.getBasepath('/images/player/stop.svg')} width={22} height={22}/>;
    const prevIcon = <Image src={LIB.getBasepath('/images/player/previous.svg')} width={22} height={22}/>;
    const nextIcon = <Image src={LIB.getBasepath('/images/player/next.svg')} width={22} height={22}/>;
    const autoIconOff = <Image src={LIB.getBasepath('/images/player/repeat-off.svg')} width={22} height={22}/>;
    const autoIconOn = <Image src={LIB.getBasepath('/images/player/repeat-on.svg')} width={22} height={22}/>;
    const repeatOffIcon = <Image src={LIB.getBasepath('/images/player/repeat-single-off.svg')} width={22} height={22}/>;
    const repeatOnIcon = <Image src={LIB.getBasepath('/images/player/repeat-single-on.svg')} width={22} height={22}/>;
    const forward15sec = <Image src={LIB.getBasepath('/images/player/forward-15.svg')} width={22} height={22}/>;
    const backward15sec = <Image src={LIB.getBasepath('/images/player/backward-15.svg')} width={22} height={22}/>;
    
    useEffect(() => {
        console.log('currentPosition: ' + currentPosition);
        initRepeatMode();
    }, []);

    useEffect(() => {
        localStorage.setItem('podcastRepeatMode', repeatMode);
    }, [repeatMode]);
    
    useEffect(() => {
        localStorage.setItem('podcastAutoPlay', autoPlay ? 'on' : 'off');
    }, [autoPlay]);


    const initRepeatMode = () => {
        let savedSetting = localStorage.getItem('podcastRepeatMode');

        if (savedSetting != null) {
            setRepeatMode(savedSetting);
        }
        else {
            localStorage.setItem('podcastRepeatMode', repeatMode);
        }
    }

    const handleSeekMouseDown = (e) => {
        if (playPauseButtonState != 'buffering') {
            setSeeking(true);
        }
    }

    const handleSeekMouseUp = (e) => {
        //this mouseup on is not work ios
        setSeeking(false);
        //player.current.seekTo(parseFloat(e.target.value));
    }

    function formatTime(seconds) {
        const date = new Date(seconds * 1000)
        const hh = date.getUTCHours()
        const mm = date.getUTCMinutes()
        const ss = pad(date.getUTCSeconds())

        if (hh) {
            return `${hh}:${pad(mm)}:${ss}`
        }

        return `${mm}:${ss}`
    }

    function pad(string) {
        return ('0' + string).slice(-2);
    }

    // Old method
    // const toggleRepeat = () => {
    //     if (typeof window !== "undefined") {
    //         let state;
    //         if (repeatMode == REPEAT_OFF) state = REPEAT_ONE;
    //         else if (repeatMode == REPEAT_ONE) state = REPEAT_ALL;
    //         else state = REPEAT_OFF;

    //         setRepeatMode(state);
    //         onToggleRepeat(state);
    //     }
    // }
    
    const renderAutoBtn = () => {
        let btn = <div className={styles.playerBtn}>{autoIconOff}</div>;

        if (LIB.detectIos() || LIB.detectSafari()) {
            btn = <div className={styles.playerBtn} onClick={() => { toggleAutoPlay(false) }}>{autoIconOff}</div>;
        } else {
            btn = <div className={styles.playerBtn} onClick={() => { toggleAutoPlay() }}>{autoPlay == true ? autoIconOn : autoIconOff}</div>;
        }
        return btn;
    }
    
    const renderRepeatBtn = () => {
        let btn = <div className={styles.playerBtn}>{repeatOffIcon}</div>;

        if (repeatMode == REPEAT_ONE) {
            //repeat OFF
            btn = <div onClick={() => { toggleRepeatOne() }} className={styles.playerBtn}>{repeatOnIcon}</div>;
        } else {
            //repeat single one
            btn = <div onClick={() => { toggleRepeatOne() }} className={styles.playerBtn}>{repeatOffIcon}</div>;
        }

        return (
            <>{btn}</>
        );
    }
    
    const toggleAutoPlay = () => {
        if (typeof window !== "undefined") {
            // let state;
            // if (repeatMode == REPEAT_OFF) state = REPEAT_ALL;
            // else if (repeatMode == REPEAT_ONE) state = REPEAT_ALL;
            // else state = REPEAT_OFF;
            
            let state = (autoPlay == true ? false : true);
            setAutoPlay(state);
            
            // setRepeatMode(state);
            // onToggleRepeat(state);
        }
    }
    
    const toggleRepeatOne = () => {
        if (typeof window !== "undefined") {
            let state;
            if (repeatMode == REPEAT_ONE) state = REPEAT_OFF;
            else state = REPEAT_ONE;

            setRepeatMode(state);
            onToggleRepeat(state);
        }
    }

    const renderForward15sec = () => {
        return (
            <div className={styles.playerBtn} onClick={() => { updateForwardBackwardTime('f') }}>{forward15sec}</div>
        );
    }
    
    //onClickForward
    const renderBackward15sec = () => {
        return (
            <div className={styles.playerBtn} onClick={onClickRewind}>{backward15sec}</div>
        );
    }

    const renderPrevBtn = () => {        
        return (<div className={styles.playerBtn} onClick={(e) => onClickPrevTrack(e)}>{prevIcon}</div>);
    }
    
    const renderNextBtn = () => {
        return (<div className={styles.playerBtn} onClick={(e) => onClickNextTrack(e)}>{nextIcon}</div>);
    }

    return (
        <div className={styles.playerWrapper}>
            <div className={styles.player}>
                <div className={styles.timeContainer}>
                    <div className={styles.audioTitle} onClick={onClickTitle}>{title}</div>
                </div>
                <div className={styles.rangeContainer}>
                    <div className={playPauseButtonState == 'buffering' ? styles.rangeHolderBuffering : styles.rangeHolder}>
                        <input
                            className={playPauseButtonState == 'buffering' ? styles.rangeBuffering : styles.range}
                            type='range'
                            min={0} max={0.9999999}
                            step={0.0000001}
                            value={(totalDuration == 0 ? 0 : currentPosition / totalDuration)}
                            tooltip="off"
                            onMouseDown={(handleSeekMouseDown)}
                            onChange={onSeekBarChanged}
                            onMouseUp={handleSeekMouseUp}
                            style={{ 'background': `linear-gradient(to right, #cce4ed ${(currentPosition * 100 / totalDuration)}%, #fff 0px` }}
                        />
                    </div>
                </div>
                <div className={styles.timeContainer}>
                    <div className={styles.timeCurrent}>{formatTime(currentPosition)} / {formatTime(totalDuration)}</div>
                    <div className={styles.timeTotal}>-{formatTime(Math.max(0, totalDuration - currentPosition))}</div>
                </div>
                <Container fluid className={styles.btnHolder}>
                    <Row>
                        <Col xs={12}>
                            <div className={styles.center}>
                                {renderAutoBtn()}
                                {renderBackward15sec()}
                                {renderPrevBtn()}
                                <div className={playPauseButtonState == 'buffering' ? `${styles.playStopBtnBuffering} ${styles.playerBtn}` : `${styles.playStopBtn} ${styles.playerBtn}`} onClick={(e) => onClickPlayPause(e)}>
                                    {playPauseButtonState == 'playing' || playPauseButtonState == 'buffering' ? stopIcon : playIcon}
                                </div>
                                {renderNextBtn()}
                                {renderForward15sec()}
                                {renderRepeatBtn()}                           
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
}

export default PodcastPlayerBar;